import { login, getBusinessCenter, loginEmail, logout } from '@/api/user'
import { Message } from 'element-ui'
import { setToken, removeToken } from '@/store/local/auth'

const getDefaultState = () => {
  return {
    name: '',
    avatar: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
/*   loginEmail({ commit }, data) {
    const { mobile, code } = data
    return new Promise((resolve, reject) => {
      loginEmail({ mobile: mobile, code: code })
        .then(response => {
          if (response.data.code == 1) {
            setToken(response.data.data.token)
            location.reload()
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
    })
  }, */
  loginEmail({ commit, dispatch }, data) {
    const { mobile, code } = data;
    return new Promise((resolve, reject) => {
      // 调用 businessMobileLogin API，传递正确的参数格式
      loginEmail({ 
        code: code,
        mobile: mobile,
        scene: 'YZMDL',
        terminal: 4
      })
        .then(response => {
          if (response.data.code === 1) {
            const { token, mobile, id, is_verified } = response.data.data;
            setToken(token);
            console.log('token', token);
            commit('SET_NAME', mobile);
            commit('SET_AVATAR', '');
            dispatch('auth/setLoginStatus', true, { root: true });
            if (is_verified === 0) {
              return getBusinessCenter().then(businessResponse => {
                if (businessResponse.data.code === 1) {
                  const businessData = businessResponse.data.data;
                  commit('SET_NAME', businessData.name || mobile);
                  commit('SET_AVATAR', businessData.avatar || '');
                  Message({
                    message: '您已成功登录，用户：' + (businessData.name || mobile),
                    type: 'success',
                    duration: 5 * 1000
                  });
                  // 返回包含企业信息的响应
                  resolve({
                    ...response.data,
                    businessInfo: businessData,
                    needVerification: true
                  });
                } else {
                  resolve({
                    ...response.data,
                    needVerification: true
                  });
                }
              }).catch(error => {
                console.error('企业认证失败:', error);
                resolve({
                  ...response.data,
                  needVerification: true
                });
              });
            } else {
              Message({
                message: '您已成功登录，用户：' + mobile,
                type: 'success',
                duration: 5 * 1000
              });
              resolve(response.data);
            }
          } else {
            reject(new Error('登录失败：' + response.data.msg));
          }
        })
        .catch(error => reject(error));
    });
  },

  // TODO: user login 用户登录，获取到token、name和avatar
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        setToken(data.token)
        commit('SET_NAME', data.name)
        commit('SET_AVATAR', data.avatar)
        Message({
          message: '您已成功登录，用户：' + data.token,
          type: 'success',
          duration: 5 * 1000
        })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // TODO: get user info 用户修改账号信息后重新获取name和avatar
  // getInfo({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token).then(response => {
  //       const { data } = response
  //       if (!data) {
  //         return reject('Verification failed, please Login again.')
  //       }
  //       const { name, avatar } = data
  //       commit('SET_NAME', name)
  //       commit('SET_AVATAR', avatar)
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getBusinessCenter().then(response => {
        const { data } = response
        if (!data) {
          return reject('获取用户信息失败，请重新登录')
        }
        console.log('getInfo response', data);
        
        const { name, avatar } = data.data
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout 用户登出，重设状态
  logout({ commit, dispatch }) {
    return new Promise(() => {
      logout().then(response => {
        if (response.data.code == 1) {
          removeToken()
          commit('RESET_STATE')
          // 设置未登录状态
          dispatch('auth/logout', null, { root: true });
          location.reload()
        }
      })
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

